import { Empty } from "antd";
import { HTMLAttributes, useEffect, useRef, useState } from "react";
import CaretDown from "../Icons/CaretDown";
import "./style.css";

interface YudlSelectProps extends HTMLAttributes<HTMLDivElement> {
    label?: string;
    containerStyle?: string;
    options: Record<any, any>[];
    labelField: any;
    valueField: any;
    value?: any;
    placeholder?: string;
    onChange?: (val: any) => void;
    invalidFeedback?: string;
    isInvalid?: boolean;
}

const YudlSelect = (prop: YudlSelectProps) => {
    const [showOptions, setShowOptions] = useState(false);

    let {
        onChange,
        options,
        labelField,
        valueField,
        label,
        value = "",
        isInvalid,
        invalidFeedback,
        placeholder,
        containerStyle = "",
        ...props
    } = prop;

    const filtercontainer = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const listener = (e: any) => {
            if (!filtercontainer.current?.contains(e.target)) {
                setShowOptions(false);
            }
        };

        document.addEventListener("click", listener);

        return () => document.removeEventListener("click", listener);
    }, [setShowOptions]);

    const handleSelect = (val: any) => {
        onChange?.(val);
        setShowOptions(false);
    };

    options = options.filter(f => f[labelField] !== value);

    return (
        <div className={`yudl-select-control my-3 ${containerStyle}`} ref={filtercontainer} {...props}>
            {label && (
                <label className="text-theme yudl-label" onClick={() => setShowOptions(prev => !prev)}>
                    {label}
                </label>
            )}
            <div
                className={`yudl-select d-flex justify-content-between align-items-center cursor-pointer ${isInvalid ? "border-danger" : ""}`}
                onClick={() => setShowOptions(prev => !prev)}
            >
                {value && <span className="text-theme">{value}</span>}
                {!value && <span className="yudl-select-placeholder">{placeholder}</span>}
                <span>
                    <CaretDown color={isInvalid ? "red" : undefined} />
                </span>
            </div>
            {isInvalid && <small className="text-danger">{invalidFeedback}</small>}
            {showOptions && (
                <div className="yudl-select-options-container">
                    {options.map((record, index) => (
                        <div key={index} className="yudl-option" onClick={() => handleSelect(record[valueField])}>
                            {record[labelField]}
                        </div>
                    ))}
                    {options.length < 1 && <div className="d-flex justify-content-center" children={<Empty />} />}
                </div>
            )}
        </div>
    );
};

export default YudlSelect;
